

































import { Component } from "vue-property-decorator";

import Wrapper from "./Wrapper.vue";

import Input from "./input";

@Component({ components: { Wrapper } })
export default class SimpleInput extends Input {
  removeTransition() {
    this.input.style.transition = "none";
  }

  addTransition() {
    this.input.style.transition = ".2s";
  }

  textScroller() {
    const scroll = this.input.scrollHeight;
    const offset = this.input.offsetHeight;
    if (scroll > 80 && scroll > offset) {
      this.input.scrollTop = scroll;
    }
  }

  mountedUtility() {
    this.textScroller();
  }
}
